import {AfterViewInit, Component, Input, OnInit} from "@angular/core";
import {AlertService} from "./alert.service";

// declare let jQuery:any;

@Component({
	selector: "tig-alert",
	template: `<div *ngIf="OBJ_message" id="tig-alert" [ngClass]="{'alert': OBJ_message, 'alert-success': OBJ_message.type === 'success', 'alert-danger': OBJ_message.type === 'error', 'alert-info': OBJ_message.type === 'info'}">
		{{OBJ_message.text | translate}}
	</div>`
})
export class AlertComponent implements OnInit, AfterViewInit
{


	/**
	 * Attributes
	 */
	OBJ_message: any;
	@Input()
	INT_duration: any = 3000;


	/**
	 * Function > constructor
	 * @param {object} OBJ_alert_service
	 */
	constructor(private OBJ_alert_service: AlertService) {} // end function constructor


	/**
	 * Function > ngOnInit
	 */
	ngOnInit()
	{
		// Nachricht ueber Navigation hinweg vefuellt
		if(this.OBJ_alert_service.getMessageAfterNavChange() != null)
		{
            this.OBJ_message = this.OBJ_alert_service.getMessageAfterNavChange();
		} // end if

		// Nachricht auf lokaler Seite ausgegeben
		this.OBJ_alert_service.getMessage().subscribe(OBJ_message => {

			if(OBJ_message!=null)
			{
                this.OBJ_message = OBJ_message;
			}

		});

	} // end function ngOnInit


	/**
	 * Function > ngAfterViewInit
	 */
	ngAfterViewInit(): void
	{

		// console.log(jQuery("#tig-alert"));
		// jQuery("#tig-alert").fadeOut(this.INT_duration, () => {
		// 	console.log("fertig");
		// })

	} // end function ngAfterViewInit


} // end class AlertComponent
